module.exports = __webpack_public_path__ + "static/img/equipment_loan_user_feedback.14078b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/equipment_loan_user_feedback.png
// module id = 1694
// module chunks = 5